import { render } from "./Wheel2.vue?vue&type=template&id=158f81ca"
const script = {}
script.render = render

export default script